module["exports"] = ["Ing.", "Mgr.", "JUDr.", "MUDr."];